<template>
  <button
    :class="['button', themeClass, sizeClass, buttonClass]"
    :type="type"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'

  export default defineComponent({
    name: 'Button',
    props: {
      type: {
        type: String as PropType<'button' | 'submit' | 'reset'>,
        default: 'button',
      },
      buttonClass: {
        type: String,
        default: '',
      },
      theme: {
        type: String as PropType<'primary' | 'secondary'>,
        default: 'primary',
      },
      size: {
        type: String as PropType<'small' | 'medium'>,
        default: 'medium',
      },
    },
    emits: ['click'],
    computed: {
      themeClass() {
        return this.theme === 'secondary'
          ? 'button--secondary'
          : 'button--primary'
      },
      sizeClass() {
        return this.size === 'small' ? 'button--small' : 'button--medium'
      },
    },
    methods: {
      handleClick(event: Event) {
        this.$emit('click', event)
      },
    },
  })
</script>

<style lang="scss" scoped>
  //Button use global style .button from style.scss
</style>
